export default __webpack_public_path__ + "maps-examples-user-tracking-mode-thumbnail-960-3b03693047589a4b4188704ed469e9b8.webp";